import { render, staticRenderFns } from "./OfferCard.vue?vue&type=template&id=6b811bd6&scoped=true&"
import script from "./OfferCard.vue?vue&type=script&lang=ts&"
export * from "./OfferCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b811bd6",
  null
  
)

export default component.exports
import QList from 'quasar/src/components/item/QList.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QList,QSpace,QBtn});
